










































import Vue from 'vue';

interface errorSentence {
  pattern: string;
  required: string;
  enum: string;
  minimum: string;
  maximum: string;
  exclusiveMinimum: string;
  exclusiveMaximum: string;
  multipleOf: string;
  minLength: string;
  maxLength: string;
  minItems: string;
  maxItems: string;
  uniqueItems: string;
  minProperties: string;
  maxProperties: string;
}

export default Vue.extend({
  props: ['data'],
  data(): {
    errorSentence: errorSentence;
  } {
    return {
      errorSentence: {
        pattern: '지정한 정규표현식에 맞지 않습니다.',
        required: '해당 속성은 반드시 필요한 속성입니다',
        enum: '지정한 category에 포함되지 않습니다.',
        minimum: '지정한 최소값보다 작습니다.',
        maximum: '지정한 최대값보다 큽니다.',
        exclusiveMinimum: '지정한 최소값보다 작거나 같습니다.',
        exclusiveMaximum: '지정한 최대값보다 크거나 같습니다.',
        multipleOf: '지정한 값의 배수가 아닙니다.',
        minLength: '지정한 문자열의 최소길이보다 작습니다.',
        maxLength: '지정한 문자열의 최대길이보다 큽니다.',
        minItems: '지정한 배열의 최소크기보다 작습니다.',
        maxItems: '지정한 배열의 최대크기보다 큽니다.',
        uniqueItems: '배열의 모든 값이 유일하지 않습니다.',
        minProperties: '지정한 속성의 최소개수보다 작습니다.',
        maxProperties: '지정한 속성의 최대개수보다 큽니다',
      },
    };
  },
  created() {
    for (let index in this.data.errorList) {
      this.data.errorList[index].property = this.data.errorList[index].property
        .replace('/', '.')
        .slice(1);
    }
  },
  methods: {
    decorateErrorData(error: { keyword: string; givenData: any }) {
      if (error.keyword === 'minItems' || error.keyword === 'maxItems') {
        return error.givenData.length;
      } else {
        return error.givenData;
      }
    },
  },
});
